/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Liwg
 * @date  2024/09/11 14:32
 * @des  需要国际化的中文
 */

module.exports = {
  common_common: {
    appName: 'DiDa Learning',
    handelSuccess: 'Action Succeeded',
    handelFail: 'Action Failed',
    requestErr: 'Error getting data',
    delete: 'Delete',
    account: {
      loggedOff: 'Account Deleted',
      blocked: 'Account Frozen',
    },
    timeUtil: {
      justNow: 'Just now',
      minuteAgo: '{time} minutes ago',
      yesterday: '{time} Yesterday',
      day: ' day(s) ',
      hour: ' hour(s) ',
      minute: ' minute(s) ',
      seconds: ' second(s) '
    },
  }
}



// WEBPACK FOOTER //
// ./src/common/i18n/en.js